exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "schedule-mobile{pointer-events:none}schedule-mobile .container.hpd.responsiveMobile.schedule-mobile{padding-left:0;padding-right:0}schedule-mobile .container.hpd.responsiveMobile calendar-component{margin-bottom:0}schedule-mobile .container.hpd.responsiveMobile calendar-component .datepicker-days{height:280px;margin-bottom:20px;box-shadow:0 2px 4px 0 #dddfe2!important;padding-left:30px;padding-right:30px}schedule-mobile .container.hpd.responsiveMobile calendar-component th{font-size:12px}schedule-mobile .container.hpd.responsiveMobile calendar-component td{font-size:15px}schedule-mobile .container.hpd.responsiveMobile calendar-component .icon-approved,schedule-mobile .container.hpd.responsiveMobile calendar-component .icon-requested{left:10px;float:right}schedule-mobile .container.hpd.responsiveMobile calendar-component .new,schedule-mobile .container.hpd.responsiveMobile calendar-component .old{visibility:hidden}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./client/app/vacations-absences.module/features/scheduleMobile/scheduleMobile.scss
// module id = 1364
// module chunks = 0